// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".note-image[data-v-304e303e]{cursor:pointer;height:25px}.with-text.btn-link[data-v-304e303e]{color:#17a2b7 !important}", ""]);
// Exports
module.exports = exports;
